// Generate a hex color from a string with minimum brightness
export function stringToHexColor(str: string): string {
  if (str === 'Night Shift_dark') return '#000000';
  if (str === 'Day Shift_dark') return '#ffffff';
  if (str === 'Night Shift_light') return '#000000';
  if (str === 'Day Shift_light') return '#ffffff';

  if (str === 'Bucket' || str === 'Mucking') return `#10B981`;
  else if (str === 'Bolt') return `#8191d3`;
  else if (str === 'Drill') return `#c19a6b`;
  else if (str.includes('2490')) return `#2490ff`;
  // else if (str.includes('2485')) return `#80471c`;
  else if (str.includes('2485')) return `#24d5ff`;
  // else if (str === 'Demobilization') return `#d2f6e6`;
  // else if (str === 'Mobilization') return `#d2f6e6`;

  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const r = (hash & 0xff0000) >> 16;
  const g = (hash & 0x00ff00) >> 8;
  const b = hash & 0x0000ff;
  const minBrightness = 60;
  const adjustedR = Math.max(r, minBrightness);
  const adjustedG = Math.max(g, minBrightness);
  const adjustedB = Math.max(b, minBrightness);
  return `#${((adjustedR << 16) | (adjustedG << 8) | adjustedB)
    .toString(16)
    .padStart(6, '0')}`;
}

export interface ShiftItem {
  x: string;
  y: [number, number];
  type: string;
}

// Generate day and night shift time ranges between dates
export function generateShiftData(startDate: Date, endDate: Date): ShiftItem[] {
  const shifts: ShiftItem[] = [];
  const start = new Date(
    startDate.getFullYear(),
    startDate.getMonth(),
    startDate.getDate()
  );
  const endDay = new Date(
    endDate.getFullYear(),
    endDate.getMonth(),
    endDate.getDate()
  );
  const d = new Date(start);
  // eslint-disable-next-line no-unmodified-loop-condition
  while (d <= endDay) {
    const y = d.getFullYear();
    const m = d.getMonth();
    const dt = d.getDate();
    const dayStartUtc = Date.UTC(y, m, dt, 6, 0, 0);
    const dayEndUtc = Date.UTC(y, m, dt, 18, 0, 0);
    shifts.push({
      x: 'Shifts',
      y: [dayStartUtc, dayEndUtc],
      type: 'Day Shift',
    });
    const nightStartUtc = Date.UTC(y, m, dt, 18, 0, 0);
    const next = new Date(d);
    next.setDate(dt + 1);
    const nightEndUtc = Date.UTC(
      next.getFullYear(),
      next.getMonth(),
      next.getDate(),
      6,
      0,
      0
    );
    shifts.push({
      x: 'Shifts',
      y: [nightStartUtc, nightEndUtc],
      type: 'Night Shift',
    });
    d.setDate(d.getDate() + 1);
  }
  return shifts;
}
